import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import IVPatientJobsTable from "./ivr-patient-jobs-table";
import {
  queryInit,
  updateQuery,
  resetQueryApiAndParams,
  Types as QueryTypes
} from "../../features/query/actions";
import Radium from "radium";
import { PageHeader } from "components/ui";
import UpdateJobsForms from "./update-jobs-forms";

class JobsProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  updateRequestDictionary(input) {
    const dictionary = {
      S3_PatientAddress: "Patient",
      S3_Patient: "Patient",
      S3_OrderAddresses: "Order",
      sStreet: "Street",
      sCity: "City",
      sState: "State",
      sZip: "Zip Code"
    };
    let result = dictionary[input];
    if (result == undefined || result == null) {
      return "";
    } else {
      return result;
    }
  }

  render() {
    const {
      loadOrder,
      loadPatient,
      updateRequestsRecords,
      patientGuidForJobs,
      query
    } = this.props;
    // Default to [] so the .includes() below stays safe before the
    // table's first fetch resolves.
    let updateRequestRecordIds =
      (query &&
        query.apiById &&
        query.apiById.IVRPatientJobs &&
        query.apiById.IVRPatientJobs.ids) ||
      [];
    let updateRequestsToArrayOfMaps =
      updateRequestsRecords && updateRequestsRecords.toIndexedSeq().toArray();
    let updateRequestsToArray =
      updateRequestsToArrayOfMaps &&
      updateRequestsToArrayOfMaps
        .map(map => map.toJS())
        .filter(x => updateRequestRecordIds.includes(x.id));

    let needsForm = updateRequestsToArray && updateRequestsToArray.length > 0;

    return (
      <React.Fragment>
        <div>
          <PageHeader title="Jobs" />
          {/* Persistent navigation to the patient profile. Without this,
              once the last unprocessed job is submitted the jobs table
              empties and there's no remaining link to the patient (the
              "Patient" column links live on the rows themselves). */}
          {patientGuidForJobs && (
            <div style={{ marginBottom: "10px" }}>
              <button onClick={() => loadPatient(patientGuidForJobs)}>
                View Patient Profile
              </button>
            </div>
          )}
          <IVPatientJobsTable
            queryId="IVRPatientJobs"
            apiId="IVRPatientJobs"
            loadOrder={loadOrder}
            loadPatient={loadPatient}
            updateRequestDictionary={this.updateRequestDictionary}
            patientGuidForJobs={patientGuidForJobs}
          />
          {needsForm && (
            <div style={{ marginTop: "20px" }}>
              <UpdateJobsForms
                patientGuidForJobs={patientGuidForJobs}
                updateRequestsToArray={updateRequestsToArray}
                onSuccess={() => this.props.refreshJobs(patientGuidForJobs)}
              />
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default connect(
  state => ({
    query: state.getIn(["query"]),
    updateRequestsRecords: state.getIn(["entities", "ivrPatientJobs"])
  }), //  "apiById" "IVRPatientJobs", "ids"
  dispatch => ({
    ...bindActionCreators(
      {
        queryInit,
        updateQuery,
        resetQueryApiAndParams
      },
      dispatch
    ),
    // Trigger a fresh fetch of the patient's jobs after a work-table
    // form submit. Mirrors the initialQuery in ivr-patient-jobs-table.jsx
    // so the table re-renders with this patient's unprocessed jobs only.
    // QUERY_REQUEST_DATA is the only action that actually fires the
    // fetch (features/query/sagas.js); RESET_API_AND_PARAMS just clears
    // state and does not refetch.
    refreshJobs: patientGuidForJobs =>
      dispatch({
        type: QueryTypes.REQUEST_DATA,
        payload: {
          query: {
            sort: {},
            pagination: { per: 15, page: 1 },
            filters: {
              patient_guid: [patientGuidForJobs],
              processed: ["false"]
            },
            searches: {}
          },
          method: "PUT",
          route: "IVR/Work/Jobs",
          responseKey: "jobs",
          entityKey: "ivrPatientJobs",
          idKey: "id"
        },
        meta: { apiId: "IVRPatientJobs" }
      })
  })
)(Radium(JobsProfile));

JobsProfile.propTypes = {
  loadOrder: PropTypes.func.isRequired,
  query: PropTypes.object.isRequired,
  loadPatient: PropTypes.func.isRequired,
  patientGuidForJobs: PropTypes.string,
  updateRequestsRecords: PropTypes.object,
  refreshJobs: PropTypes.func.isRequired
};
